
<template>
    <div :class="[
            'form__group',
            { 'form--error' : error },
            { 'form--hidden' : hidden }
        ]"
        :aria-hidden="hidden"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        error: {
            type: Boolean,
            default: false
        },
        hidden: {
            type: Boolean,
            default: false
        }
    }
}
</script>

